import { POST } from "../../index";

export const login = (param) => POST("/v1/user/login", param);
